import React from 'react';

const RosterVersion = React.createContext(-1);

export default RosterVersion;
